import React, { useState } from 'react';

function WaitlistScreen({ country, onSubmit, onBack }) {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email.trim() && email.includes('@')) {
      onSubmit(email);
    }
  };

  return (
    <div className="screen-container">
      <button className="back-button" onClick={onBack}>←</button>
      
      <div className="content-card">
        <div className="logo-container">
          <div className="logo">H</div>
          <div className="logo-text">Homie</div>
          <p className="tagline">Track all your shippings in one place</p>
        </div>
        
        <div className="waitlist-content">
          <div className="waitlist-flag">{country.flag}</div>
          <h2 className="waitlist-title">Coming Soon to {country.name}</h2>
          <p className="waitlist-description">
            We're not available in {country.name} yet, but we're working hard to bring Homie to you soon!
          </p>
          <p className="waitlist-description">
            Join our waitlist and be the first to know when we launch.
          </p>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input
              type="email"
              className="phone-input"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          
          <button 
            type="submit" 
            className="submit-button"
            disabled={!email.trim() || !email.includes('@')}
          >
            Join Waitlist
          </button>
        </form>

        <p className="waitlist-note">
          We'll send you an email as soon as we're available in your country.
        </p>
      </div>
    </div>
  );
}

export default WaitlistScreen;
